import { CommandRequestType } from 'app/services/authentication/connection/commandRequestType';
import { ICommandParameters } from 'app/services/authentication/connection/iCommandParameters';
import { ICommandResponse } from 'app/services/authentication/connection/iCommandResponse';
import { ErrorDetails } from 'app/services/authentication/connection/interfaces/apiInterfaces';
import { IRequestCommand } from 'app/services/authentication/connection/iRequestCommand';

export class GetOwnersPaginatedCommand extends IRequestCommand<
  IGetOwnersPaginatedResponse,
  ErrorDetails,
  IGetOwnersPaginatedCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl =
    'carriers/{carrierId}/vehicleOwners/paginated?page={page}&size={size}&column={column}&sort={sort}&find={find}';

  public override setParameters(parameters: IGetOwnersPaginatedCommandParameters) {
    this._commandUrl = this._commandUrl
      .replace('{carrierId}', parameters.carrierId.toString())
      .replace('{page}', parameters.page.toString())
      .replace('{size}', parameters.size.toString())
      .replace('{column}', parameters.column.toString())
      .replace('{sort}', parameters.sort.toString())
      .replace('{find}', (parameters.find ?? '').toString());
  }
}

export interface IGetOwnersPaginatedCommandParameters extends ICommandParameters {
  carrierId: string;
  page: number;
  size: number;
  column: string;
  sort: string;
  find?: string;
}

export interface IGetOwnersPaginatedResponse extends ICommandResponse {
  content: any[];
  totalElements: number;
  totalPages: number;
  pageable: { pageNumber: number };
}
